import PropTypes from 'prop-types';
import clone from 'clone';

export const OEManualViewLinks = {
    app:                                    'app',
    welcome:                                'welcome',
    controls:                               'controls',
    functions:                              'functions',
    cut:                                    'cut',
    arrow:                                  'arrow',
    userObject:                             'userObject',
    note:                                   'note',
    component:                              'component',
    color:                                  'color',
    substructure:                           'substructure',
    search:                                 'search',
    selection:                              'selection',
    contextMenu:                            'contextMenu',
    modelState:                             'modelState',
    label:                                  'label',
    presentation:                           'presentation',
    screenshot:                             'screenshot',
    mediaCenter:                            'mediaCenter',
    settings:                               'settings',
    videoTutorial:                          'videoTutorial'
};

//
export const OEManualViewLinkType = {
    none:                                   'none',
    pdf:                                    'pdf',
    youtube:                                'youtube',
    video:                                  'video'
};

//
export const OEManualViewPropTypes = {

    linkDecl: {
        link:                               PropTypes.string.isRequired,
        type:                               PropTypes.oneOf([OEManualViewLinkType.pdf, OEManualViewLinkType.youtube, OEManualViewLinkType.video]).isRequired,
        ref:                                PropTypes.string,
        refId:                              PropTypes.string,
        page:                               PropTypes.number
    }
};

OEManualViewPropTypes.link = PropTypes.shape(OEManualViewPropTypes.linkDecl);

OEManualViewPropTypes.links = PropTypes.arrayOf(OEManualViewPropTypes.link);

OEManualViewPropTypes.configDecl = {
    logo:                                   PropTypes.string,
    title:                                  PropTypes.string,
    titleId:                                PropTypes.string,
    showAtStartUp:                          PropTypes.bool,
    links:                                  OEManualViewPropTypes.links
};

OEManualViewPropTypes.config = PropTypes.shape(OEManualViewPropTypes.configDecl);

OEManualViewPropTypes.optionsDecl = {
    link:                                   PropTypes.string,
    title:                                  PropTypes.string,
    titleId:                                PropTypes.string,
    links:                                  OEManualViewPropTypes.links
};

OEManualViewPropTypes.options = PropTypes.shape(OEManualViewPropTypes.optionsDecl);

//
export class OEManualViewConfigFactory {

    constructor(config, ref = true) {
        this.set(config, ref);
    }

    set(config, ref = false)    {      // ref == true -> overwrite reference
        if(typeof(config) !== 'object' || config === null)    {
            if(!ref && this.config) {
                this.config.logo            = undefined;
                this.config.title           = undefined;
                this.config.titleId         = 'help_view_manual';
                this.config.showAtStartUp   = false;

                if(!Array.isArray(this.config.links)) {
                    this.config.links = [];
                } else {
                    if(this.config.links.length) this.config.links.splice(0, this.config.links.length);
                }

            } else {
                this.config = {
                    titleId:                'help_view_manual',
                    showAtStartUp:          false,
                    links:                  []
                };
            }
            return this;
        }

        if(ref) {
            this.config = config;
            if(!Array.isArray(this.config.links))    this.config.links = [];
        } else {
            if(!this.config)    this.config = {};

            this.config.logo                = config.logo;
            this.config.title               = config.title;
            this.config.titleId             = config.titleId;
            this.config.showAtStartUp       = config.showAtStartUp;

            if(!Array.isArray(this.config.links))    this.config.links = [];
            this.config.links.splice(0, this.config.links.length);
            if(Array.isArray(config.links))      this.config.links.splice(this.config.links.length, 0, ...config.links);
        }

        return this;
    }

    build(copy = true)   {
        if(!copy)    return this.config;
        return clone(this.config);
    }

    clear() {
        return this.set(undefined, false);
    }

    std()   {
        return this.set(OEManualViewConfigFactory.buildStdConfig(), false);
    }

    stdPDF(withSubstructure = false)  {
        return this.set(OEManualViewConfigFactory.buildStdPDFConfig(withSubstructure), false);
    }

    setLogo(logo)   {
        this.config.logo = logo;
        return this;
    }

    setTitle(title)   {
        this.config.title = title;
        return this;
    }

    setTitleId(titleId)   {
        this.config.titleId = titleId;
        return this;
    }

    setShowAtStartUp(showAtStartUp)   {
        this.config.showAtStartUp = showAtStartUp;
        return this;
    }

    setLinks(links)   {
        this.config.links = Array.isArray(links) ? clone(links) : [];
        return this;
    }

    addLink(link)   {
        this.removeLink(link);
        this.config.links.push(link);
        return this;
    }

    removeLink(link)    {
        this.config.links = this.config.links.filter(e => e.link !== link);
        return this;
    }

    setVideoTutorialLink(refId) {
        this.removeLink(OEManualViewLinks.videoTutorial);
        if(refId === null)  return this;
        return this.addLink({link: OEManualViewLinks.videoTutorial, type: OEManualViewLinkType.video, refId: typeof(refId) === 'string' ? refId : 'tutorial_video'});
    }
};

OEManualViewConfigFactory.buildStdConfig = function()  {
    return {
        titleId:                            'help_view_manual',
        showAtStartUp:                      false,
        links: [
            {link: OEManualViewLinks.cut, type: OEManualViewLinkType.youtube, refId: 'tutorial_video_2_youtube'}
        ]
    };
};

OEManualViewConfigFactory.buildStdPDFConfig = function(withSubstructure)  {

    let links = [
        {link: OEManualViewLinks.app, type: OEManualViewLinkType.pdf, refId: 'manual', page: 1},
        {link: OEManualViewLinks.welcome, type: OEManualViewLinkType.pdf, refId: 'manual', page: 1},
        {link: OEManualViewLinks.controls, type: OEManualViewLinkType.pdf, refId: 'manual', page: 2},
        {link: OEManualViewLinks.functions, type: OEManualViewLinkType.pdf, refId: 'manual', page: 3},
        {link: OEManualViewLinks.contextMenu, type: OEManualViewLinkType.pdf, refId: 'manual', page: 4},
        {link: OEManualViewLinks.search, type: OEManualViewLinkType.pdf, refId: 'manual', page: 5},
        {link: OEManualViewLinks.component, type: OEManualViewLinkType.pdf, refId: 'manual', page: 6},
        {link: OEManualViewLinks.label, type: OEManualViewLinkType.pdf, refId: 'manual', page: 7},
        {link: OEManualViewLinks.note, type: OEManualViewLinkType.pdf, refId: 'manual', page: 8},
        {link: OEManualViewLinks.arrow, type: OEManualViewLinkType.pdf, refId: 'manual', page: 9},
        {link: OEManualViewLinks.cut, type: OEManualViewLinkType.pdf, refId: 'manual', page: 10},
        {link: OEManualViewLinks.color, type: OEManualViewLinkType.pdf, refId: 'manual', page: 11},
        {link: OEManualViewLinks.presentation, type: OEManualViewLinkType.pdf, refId: 'manual', page: 12},
        {link: OEManualViewLinks.mediaCenter, type: OEManualViewLinkType.pdf, refId: 'manual', page: 13},
        {link: OEManualViewLinks.settings, type: OEManualViewLinkType.pdf, refId: 'manual', page: 14}
    ];
    
    if(withSubstructure)    {
        let substructureLink = {link: OEManualViewLinks.substructure, type: OEManualViewLinkType.pdf, refId: 'manual', page: 11};
        links.push(substructureLink);

        links.forEach(link => {
            if(link.link === OEManualViewLinks.substructure)  return;
            if(typeof(link.page) === 'number' && link.page >= substructureLink.page)   link.page++;
        });
    }

    return {
        titleId:                            'help_view_manual',
        showAtStartUp:                      false,
        links:                              links
    };
};

OEManualViewConfigFactory.buildCambridgeCellConfig = function()  {
    return {
        titleId:                            'help_view_manual',
        showAtStartUp:                      false,
        links: [
            {link: OEManualViewLinks.app, type: OEManualViewLinkType.pdf, refId: 'manual', page: 1},
            {link: OEManualViewLinks.welcome, type: OEManualViewLinkType.pdf, refId: 'manual', page: 1},
            {link: OEManualViewLinks.controls, type: OEManualViewLinkType.pdf, refId: 'manual', page: 2},
            {link: OEManualViewLinks.functions, type: OEManualViewLinkType.pdf, refId: 'manual', page: 3},
            {link: OEManualViewLinks.contextMenu, type: OEManualViewLinkType.pdf, refId: 'manual', page: 4},
            {link: OEManualViewLinks.search, type: OEManualViewLinkType.pdf, refId: 'manual', page: 5},
            {link: OEManualViewLinks.component, type: OEManualViewLinkType.pdf, refId: 'manual', page: 6},
            {link: OEManualViewLinks.note, type: OEManualViewLinkType.pdf, refId: 'manual', page: 7},
            {link: OEManualViewLinks.arrow, type: OEManualViewLinkType.pdf, refId: 'manual', page: 8},
            {link: OEManualViewLinks.color, type: OEManualViewLinkType.pdf, refId: 'manual', page: 9},
            {link: OEManualViewLinks.presentation, type: OEManualViewLinkType.pdf, refId: 'manual', page: 10},
            {link: OEManualViewLinks.mediaCenter, type: OEManualViewLinkType.pdf, refId: 'manual', page: 11},
            {link: OEManualViewLinks.settings, type: OEManualViewLinkType.pdf, refId: 'manual', page: 12}
        ]
    };
};